export const WM_REPORT_SIZE_MAX_BOOK_SELECTION = 3
export const WM_REPORT_SIZE_BOOKS_OUTPUT = 30
export const AM_REPORT_SIZE_AUTHORS_OUTPUT = 20
